import { Component, OnInit, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { FestiusFilter } from '../../models/festius-filter';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-festius-filter',
  templateUrl: './festius-filter.component.html',
  styleUrls: ['./festius-filter.component.scss']
})
export class FestiusFilterComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  filter: FestiusFilter;

  @Output() notify: EventEmitter<FestiusFilter> = new EventEmitter<FestiusFilter>();

  constructor(
    public thisDialogRef: MatDialogRef<FestiusFilterComponent>,
    private i18n: I18n,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.filter = data.filter;
  }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'keypress').subscribe((e: KeyboardEvent ) => {
      if (e.key === 'Enter') {
        this.apply();
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  reset() {
    this.filter.clear();
    this.apply();
  }

  apply() {
    this.filter.updated();
    this.notify.emit(this.filter);
    this.thisDialogRef.close();
  }

  dismiss() {
    this.thisDialogRef.close();
  }

}
